export default class Settings {
    static nodeAnimationDamping: number = 0.12 // 0.12
    static nodeHorizontalSpacing: number = 500
    static nodeRowSpacing: number = 500
    static minDistBetweenTrees: number = 600
    static colorWarning: number = 0xfddbd4
    static colorNominal: number = 0xc2ecd1
}
